<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="card-table">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <i class="fas fa-2x fa-file-alt"></i>
                            </div>
                            <h4 class="title">Liste des produits</h4>
                        </div>
                        <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                            <div class="flex items-center">
                                <div>
                                    <md-button class="md-info md-sm md-button-action"
                                               @click="goToRoute('Add Product')">
                                        <md-icon class="material-icons mr-1">add</md-icon>
                                        <span>Ajouter un produit</span>
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-table :value="products" class="paginated-table" table-header-color="blue">
                        <md-table-toolbar>
                            <md-field>
                                <label for="pages">Éléments à afficher</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option
                                        v-for="item in pagination.perPageOptions"
                                        :key="item" :label="item" :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </md-table-toolbar>

                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="#">
                                {{ item.id }}
                            </md-table-cell>
                            <md-table-cell md-label="Nom">
                                <span>{{ item.name }}</span>
                            </md-table-cell>
                            <md-table-cell md-label="" style="max-width: 75px;">
                                <div class="w-full flex items-center justify-end">
                                    <md-button class="md-icon-button md-raised md-warning"
                                               @click="goToRoute('Edit Product', item.id)">
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-tooltip md-direction="top">Modifier</md-tooltip>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <p class="card-category">
                        Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
                    </p>
                    <pagination
                        class="pagination-no-border pagination-info"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                        @input="getProducts"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
    name: "Products",
    components: {
        Pagination
    },
    data() {
        return {
            products: [],
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            }
        }
    },
    methods: {
        goToRoute(route, id = null) {
            this.$router.push({name: route, params: {id}})
        },
        async getProducts() {
            let response = await this.$store.dispatch('products/getProducts', { page: this.pagination.currentPage, perPage: this.pagination.perPage })
            this.products = response.data.data
            this.pagination.total = response.data.total
        }
    },
    computed: {
        queriedData() {
            let result = this.clients;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.products.length;
        },
    },
    mounted() {
        this.getProducts()
    }
}
</script>

<style scoped>

</style>
